import React, { useEffect, useState } from "react";
import {
  ChakraProvider,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Input,
  HStack,
  useDisclosure,
  useToast
} from "@chakra-ui/react";
import axios from "axios";
import { environment } from "../environments/environment";
// import { toast } from 'react-toastify';

function OTPModal({mobile , businessKey, setGenOtp , setEntOtp , handleAgreementSigned}) {

    const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [docSigned , setIsDocSigned] = useState(false)
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // Array to store each digit

  // Handle input changes
  const generateOtp = async() => {
    try{
       let payload = new FormData();
       payload.append("phone_no" , mobile)
       payload.append("businessKey" , businessKey)
        const response = await axios.post(
            `${environment.bardWoodUrl}generate-otp`,
            payload);
            console.log("response" , response)
            setIsDocSigned(response.data.is_doc_signed)
            handleAgreementSigned(response.data.is_doc_signed)
           if(response.data.is_doc_signed === false){
            setGenOtp(response.data.otp);
            toast({
              title: 'OTP has been sent successfully !!' ,
              description: "Please Check your Whatsapp",
              status: "success", // Success status
              duration: 4000,    // Duration of the toast
              position: "top-right",
              isClosable: true,  // Option to close the toast
            });

            const nextInput = document.getElementById(`otp-input-${0}`);
            if (nextInput) nextInput.focus();
           }else{
            toast({
              title: 'Already Signed' ,
              description: "",
              status: "success", // Success status
              duration: 4000,    // Duration of the toast
              position: "top-right",
              isClosable: true,  // Option to close the toast
            });
           }
    }catch(err){
          console.log("error" , err)
    }
  }

  useEffect(() => {
    onOpen();
    generateOtp();
    

  } , [])
  const handleInputChange = (value, index) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Automatically move to the next input if value is entered
      if (value && index < otp.length - 1) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    }
  };

  // Handle backspace key to move focus back
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "" && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      if (prevInput) prevInput.focus();
    }
    if (e.key === "Enter") {
        handleSubmit();
      }
  };

  const handleSubmit =async() => {
    const enteredOtp = otp.join(""); // Combine all digits
    setEntOtp(enteredOtp)
    try{
        let payload = new FormData();
        payload.append("entered_otp" , enteredOtp)
        payload.append("businessKey" , businessKey)
         const response = await axios.post(
             `${environment.bardWoodUrl}verify-otp`,
             payload);
             console.log("response" , response);
           if(response.data === true){
            toast({
                title: "OTP Verified",
                description: "Your OTP has been successfully submitted.",
                status: "success", // Success status
                duration: 4000,    // Duration of the toast
                position: "top-right",
                isClosable: true,  // Option to close the toast
              });
            onClose();
           }else{
            toast({
                title: "Incorrect OTP",
                description: "Please fill the correct OTP.",
                status: "warning", // Success status
                duration: 4000,    // Duration of the toast
                position: "top-right",
                isClosable: true,  // Option to close the toast
              });
           }
            //  setGenOtp(response.data.otp);
            //    toast({
            //      title: response.data.otp ,
            //      description: "Your OTP has been successfully submitted.",
            //      status: "success", // Success status
            //      duration: 4000,    // Duration of the toast
            // position: "top-right",     
            // isClosable: true,  // Option to close the toast
            //    });
 
     }catch(err){
           console.log("error" , err)
     }

    // toast({
    //     title: "OTP Submitted",
    //     description: "Your OTP has been successfully submitted.",
    //     status: "success", // Success status
    //     duration: 4000,    // Duration of the toast
    // position: "top-right",    
    // isClosable: true,  // Option to close the toast
    //   });
    // onClose();
  };

  return (
    <div>
      {/* <Button onClick={onOpen} colorScheme="teal">
        Enter OTP
      </Button> */}

      {!docSigned &&  <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Enter OTP</ModalHeader>
          {/* <ModalCloseButton /> */}
          <ModalBody>
            <HStack justify="center" spacing="4">
              {otp.map((digit, index) => (
                <Input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleInputChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  textAlign="center"
                  size="lg"
                  width="50px"
                  fontSize="xl"
                />
              ))}
            </HStack>
          </ModalBody>

          <ModalFooter>
            <Button
              isDisabled={otp.join("").length < 6} colorScheme="teal" onClick={handleSubmit}>
              Verify
            </Button>
            {/* <Button variant="ghost" ml={3} onClick={onClose}>
              Cancel
            </Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>}
    </div>
  );
}

export default OTPModal;
